export default __webpack_public_path__ + "static/media/icon-megaphone-button.313ba403.svg";